import { h, createContext } from 'preact'
import { useRef, useLayoutEffect, useContext } from 'preact/hooks'
import type { ComponentChildren, JSX } from 'preact'
import SSDataEventsService from './data-events'
import { useStateValue } from '../../state-management/store'

type ContextProps = { socket: any }

const SocketContext = createContext<ContextProps>({ socket: null })

export function SocketProvider({ children }: { children?: ComponentChildren }): JSX.Element {
    const socketRef = useRef<any>(null)
    const [, dispatch] = useStateValue()

    useLayoutEffect(() => {
        if (socketRef.current === null) {
            const s = new SSDataEventsService(dispatch)
            s.connect()
            socketRef.current = s
        }
    }, [dispatch])

    return h(SocketContext.Provider as any, { value: { socket: socketRef.current } }, children as any)
}

export function useSocketService() {
    return useContext(SocketContext)?.socket
}
